import React, { useState } from "react";
import styles from "./sellers.module.scss";
import Button from "../Shared/Button";
import { useDispatch, useSelector } from "react-redux";
import { clearSellerSearch, searchSellers } from "../Redux/Reducer/appReducer";
import DataTableComponent from "../Shared/Table";
import SellerModal from "./Model";
import SellerHeader from "../../global/SellerHeader/SellerHeader";

const sellerColumns = [
  {
    name: "Name",
    selector: (row) => row.name,
    sortable: true,
    center: false,
    wrap: true,
    minWidth: "26%",
    maxWidth: "26%",
    cell: (row) => {
      return (
        <div style={{ width: "100%" }}>
          <p className={styles["table_title"]} style={{ textAlign: "left" }}>
            {row.name}
          </p>
        </div>
      );
    },
  },
  {
    name: "Email",
    selector: (row) => row.email,
    sortable: true,
    center: true,
    minWidth: "26%",
    maxWidth: "26%",
    cell: (row) => {
      return <p className={styles["table_title"]}>{row.email}</p>;
    },
  },
  {
    name: "Phone",
    selector: (row) => row.phone,
    sortable: true,
    center: true,
    minWidth: "26%",
    maxWidth: "26%",
    cell: (row) => {
      return <p className={styles["table_title"]}>{row.phone}</p>;
    },
  },
  {
    name: "Action",
    selector: (row) => row.action,
    sortable: true,
    center: true,
    minWidth: "22%",
    maxWidth: "22%",
  },
];

const Sellers = () => {
  const sellerData = useSelector(
    (state) => state?.appReducer
  )?.sellersSearchResults;
  const dispatch = useDispatch();

  const tableData = (sellerData || [])?.map((data) => {
    return {
      name: data.name,
      email: data.email,
      phone: data.phone,
      action: (
        <div>
          <>
            <Button
              style={{ width: 60, fontSize: 14, padding: 4 }}
              color={"success"}
              className={"btn btn-xs"}
              type={"button"}
              onClick={() => onPressEdit(data)}
              text={"Edit"}
            />
          </>
          &nbsp;&nbsp;
          <>
            <Button
              style={{ width: 60, fontSize: 14, padding: 4 }}
              color={"danger"}
              className={"btn btn-xs"}
              type={"button"}
              // onClick={() => onPressDelete(data)}
              disabled={true}
              text={"Delete"}
            />
          </>{" "}
        </div>
      ),
    };
  });

  // const navigation = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState([]);

  let onPressEdit = (data) => {
    setModalData(data);
    setModalOpen(true);
  };

  const toggle = () => {
    setModalOpen(!modalOpen);
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    if (query.trim() === "") {
      dispatch(clearSellerSearch());
    } else {
      dispatch(searchSellers(query));
    }
  };

  return (
    <div>
      {modalOpen && (
        <SellerModal openModal={modalOpen} toggle={toggle} data={modalData} />
      )}

      <div className={styles["sellers_container"]}>
        {
          <div className={styles["data_container"]}>
            <div className={styles["_page_header_wrapper"]}>
              <SellerHeader title="Sellers" onSearch={handleSearch} />
            </div>

            <div className={styles["table_container"]}>
              <DataTableComponent
                tableColumns={sellerColumns}
                tableData={tableData}
                highlightOnHover={true}
                onRowClicked={(row) => {}}
              />
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default Sellers;
